<template>
  <div class="grid">
    <div class="col-12 md:col-6">
      <Button
        class="w-full"
        icon="pi pi-replay"
        label="Orden original"
        @click="setList"
      />
    </div>

    <div v-if="firstCategory" class="col-12 md:col-6">
      <div class="list-group">
        <div class="list-group-item ghost">
          {{ firstCategory.titulo }}
        </div>
      </div>
    </div>

    <div class="col-12">
      <draggable
        class="list-group"
        :list="list"
        v-bind="dragOptions"
        @start="drag = true"
        @end="drag = false"
      >
        <template #item="{ element }">
          <div class="list-group-item cursor-move">
            {{ element.titulo }}
          </div>
        </template>
      </draggable>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import draggable from "vuedraggable"; // https://github.com/SortableJS/vue.draggable.next
import Button from "primevue/button";

// #region Props, Emits
const props = defineProps({
  categories: {
    type: Array,
    required: true,
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const firstCategory = ref(null);
const list = ref([]);
const drag = ref(false);

const dragOptions = computed(() => {
  return {
    animation: 200,
    ghostClass: "ghost",
  };
});
// #endregion

// #region Functions
function setList() {
  list.value = JSON.parse(JSON.stringify(props.categories));

  firstCategory.value = list.value[0];

  list.value.shift();
}
// #endregion

// #region Effects, Hooks
onMounted(() => {
  setList();
});
// #endregion

// #region Provide, Expose
defineExpose({
  firstCategory,
  list,
});
// #endregion
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

.list-group {
  min-height: 20px;

  .list-group-item {
    position: relative;
    display: block;
    padding: 0.75rem 0.75rem;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);

    &.ghost {
      opacity: 0.5;
      background: $secondary;
    }

    &:not(:first-child) {
      border-top-width: 0;
    }

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
    }

    &:last-child {
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}
</style>
